
























































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import DataScanStandmansFromTime from "@/components/lfs/NewStatistics/Elements/DataScanStandmansFromTime.vue";
import DataPerformanceStandmans from "@/components/lfs/NewStatistics/Elements/DataPerformanceStandmans.vue";
import DataPerformanceStandmansFromSurvey from "@/components/lfs/NewStatistics/Elements/DataPerformanceStandmansFromSurvey.vue";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'StandmansDashboard',
  components: {
    ErrorFetchingData,
    DataScanStandmansFromTime,
    DataPerformanceStandmans,
    DataPerformanceStandmansFromSurvey,
  }
})

export default class StandmansDashboard extends Vue {
  @statistic_v4.Getter('standmansContacts') protected standmansContacts: any
  @statistic_v4.Getter('standmansSurveys') protected standmansSurveys: any
  @statistic_v4.Getter('loading') protected loading: any
  @statistic_v4.Getter('error') protected error: any
  @statistic_v4.Action('loadStandmans') protected loadStandmans: any

  @Watch('standmansContacts')
  onStandmansContacts(_: any) {
    this.normalizedStandmansContacts = this.standmansContacts.map((contact: any) => {
      const total = contact.badges + contact.businessCards + contact.customContacts
      return {
        ...contact,
        total,
        show: total != 0
      }
    }).sort((a:any,b:any)=>b.total - a.total)
  }
  @Watch('standmansSurveys')
  onStandmansSurveys(_: any) {
    this.normalizedStandmansSurveys = this.standmansSurveys.map((contact: any) => {
      const total = contact.shardsWithFilledSurveysCount + contact.countOfFilledSurveys
      return {
        countOfFilledSurveys: contact.countOfFilledSurveys,
        shardsWithFilledSurveysCount: contact.shardsWithFilledSurveysCount,
        name: contact.name,
        show: total != 0
      }
    })

    this.normalizedSurveysOnly = this.standmansSurveys.map((contact: any) => {
      return {
        countOfFilledSurveys: contact.countOfFilledSurveys,
        percentOfFilledSurveys: contact.percentOfFilledSurveys,
        name: contact.name,
        show: !!contact.countOfFilledSurveys
      }
    })
  }

  normalizedStandmansContacts: any[] = []
  normalizedStandmansSurveys: any[] = []
  normalizedSurveysOnly: any[] = []

  protected mounted() {
    this.loadStandmans()
  }
}
